export const DATA = 'DATA'
export const data_action = (data) =>{
    return{
        type:DATA,
        payload:data
    }
}